export class StatementOfAccountProperties {
  jeid: string = "";
  jeType: string = "";
  jeDate: string = "";
  postingDateDate: string = "";
  branchCode: string = "";
  narration: string = "";
  debit: number = 0;
  credit: number;
  balance: number = 0;
  ticketNumber: string = "";
  pnrNumber: string = "";
  refrenceNumber: string = "";
  refrenceDate: string = "";
  originNo: number = 0;
  originName: string = "";
  remarks: string = "";
  glAccount: string = "";
  accountCode: string = "";
  passangerName: string = "";
  serviceType: string = "";
}
export class SearchStatementOfAccountProperties {
  fromDate: string = "";
  toDate: string = "";
  branchCode: string = "";
  accountType: string = "";
  accountCode: string = "";
  accountName: string = "";
  reverseChecked: boolean = false;
  glCode: string = "";
  userId: number=0;

  
}

export class ERPCustomerStatementReq {
  backOfficeCompany: string ="";
  customerCode: string = "";
  fromDate: string = "";
 toDate: string = "";

	}
export class PdfStatementOfAccountProperties {
  pdfPathpdfPath: string = "";
  ledgerList: StatementOfAccountProperties[];
}
